export default __webpack_public_path__ + "static/media/404-illustration.28edb791.svg";